import {vrmVueModule, injectRootVueOptions} from '../module';
import i18n from '@/vue/languages';
import {localeEvents} from '@/angular/modules/vrm.locales';

// Adds {i18n} to new Vue()
injectRootVueOptions({i18n});

vrmVueModule.run(/* @ngInject */($rootScope, locale) => {
    const bundleReferences = {};
    $rootScope.$on(localeEvents.localeChanges, (event, lang) => {
        i18n.locale = lang;
        Object.keys(bundleReferences).forEach(bundleName => {
            const usages = bundleReferences[bundleName];
            if (usages && usages > 0) {
                locale.ready(bundleName);
            }
        });
    });
    $rootScope.$on(localeEvents.resourceUpdates, (event, bundles) => {
        i18n.setLocaleMessage(i18n.locale, {...bundles});
    });

    i18n.useAngularBundle = (bundleName) => {
        if (bundleReferences[bundleName]) {
            bundleReferences[bundleName]++;
        } else {
            bundleReferences[bundleName] = 1;
        }
        return locale.ready(bundleName);
    };
    i18n.releaseAngularBundle = (bundleName) => {
        if (bundleReferences[bundleName]) {
            if (bundleReferences[bundleName] > 0) {
                bundleReferences[bundleName]--;
            }
        }
    };
});

/**
 * Causes a bundle to load when the component initializes, required for properly loading locale strings.
 * @param {string} bundleName - Name of the bundle to load when the component is initialized
 */
export function AngularLocaleBundle(bundleName) {
    console.assert(typeof(bundleName) === 'string', 'Missing valid string argument for `bundleName`');
    return (component) => {
        console.assert(!component.hasOwnProperty('cid'), '@AngularLocaleBundle must be applied below @Component');
        (component.__decorators__ || (component.__decorators__ = [])).push(options => {
            options.mixins.push({
                created() {
                    this.$i18n.useAngularBundle(bundleName);
                },
                beforeDestroy() {
                    this.$i18n.releaseAngularBundle(bundleName);
                }
            });
        });
        return component;
    };
}
